import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { TeamFilterProvider } from "@/context/TeamFilterContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Podcasts from "@/pages/Podcasts";
import Admin from "@/pages/Admin";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <TeamFilterProvider>
          <BrowserRouter>
            <div className="App min-h-screen flex flex-col">
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/podcasts" element={<Podcasts />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/admin" element={<Admin />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-right" theme="light" />
              <InstallPrompt />
            </div>
          </BrowserRouter>
        </TeamFilterProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
